import React, { Component } from "react"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/preview/template"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    const { store } = this
    return (
      <div className="bypass-account bypass">
        <h2 className="page-title">
          <img alt="" src={statisticsIcon} />模版管理
        </h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={store} />
        </div>
        <div>
          <DataTable store={store} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/preview/template/index.js